import { createSelector } from 'reselect';
import { PlanningByDateState } from '@modules/planning/children/by-date/types';

export const activeRestrictionIDsFiltersSelector = createSelector(
  (state: PlanningByDateState) => state.PlanningByDate?.filters.restriction.IDs,
  (activeRestrictionIDs) => activeRestrictionIDs?.map(Number) ?? []
);
